/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Chat } from '../models';
// @ts-ignore
import { CustomerChatMessage } from '../models';
// @ts-ignore
import { MessagesGetRequest } from '../models';
/**
 * ChatsApi - axios parameter creator
 * @export
 */
export const ChatsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get All Chats
         * @param {number} [page] Pagenumber
         * @param {number} [paginate] Items shown per page
         * @param {number} [customerId] Per customer ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsGet: async (page?: number, paginate?: number, customerId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (paginate !== undefined) {
                localVarQueryParameter['paginate'] = paginate;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customer_id'] = customerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Show specific chat
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('chatsIdGet', 'id', id)
            const localVarPath = `/chats/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get All Messages for Chat
         * @param {number} chatId For chat ID
         * @param {number} [page] Pagenumber
         * @param {number} [paginate] Items shown per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagesGet: async (chatId: number, page?: number, paginate?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('messagesGet', 'chatId', chatId)
            const localVarPath = `/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (paginate !== undefined) {
                localVarQueryParameter['paginate'] = paginate;
            }

            if (chatId !== undefined) {
                localVarQueryParameter['chat_id'] = chatId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Save Chat Message
         * @param {MessagesGetRequest} [messagesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagesPost: async (messagesGetRequest?: MessagesGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messagesGetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get All Unread Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unreadNotificationCountGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/unreadNotificationCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatsApi - functional programming interface
 * @export
 */
export const ChatsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get All Chats
         * @param {number} [page] Pagenumber
         * @param {number} [paginate] Items shown per page
         * @param {number} [customerId] Per customer ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatsGet(page?: number, paginate?: number, customerId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Chat>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatsGet(page, paginate, customerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Show specific chat
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatsIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Chat>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get All Messages for Chat
         * @param {number} chatId For chat ID
         * @param {number} [page] Pagenumber
         * @param {number} [paginate] Items shown per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagesGet(chatId: number, page?: number, paginate?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomerChatMessage>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagesGet(chatId, page, paginate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Save Chat Message
         * @param {MessagesGetRequest} [messagesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagesPost(messagesGetRequest?: MessagesGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerChatMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagesPost(messagesGetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get All Unread Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unreadNotificationCountGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unreadNotificationCountGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ChatsApi - factory interface
 * @export
 */
export const ChatsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatsApiFp(configuration)
    return {
        /**
         * Get All Chats
         * @param {number} [page] Pagenumber
         * @param {number} [paginate] Items shown per page
         * @param {number} [customerId] Per customer ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsGet(page?: number, paginate?: number, customerId?: number, options?: any): AxiosPromise<Array<Chat>> {
            return localVarFp.chatsGet(page, paginate, customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Show specific chat
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatsIdGet(id: number, options?: any): AxiosPromise<Chat> {
            return localVarFp.chatsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get All Messages for Chat
         * @param {number} chatId For chat ID
         * @param {number} [page] Pagenumber
         * @param {number} [paginate] Items shown per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagesGet(chatId: number, page?: number, paginate?: number, options?: any): AxiosPromise<Array<CustomerChatMessage>> {
            return localVarFp.messagesGet(chatId, page, paginate, options).then((request) => request(axios, basePath));
        },
        /**
         * Save Chat Message
         * @param {MessagesGetRequest} [messagesGetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagesPost(messagesGetRequest?: MessagesGetRequest, options?: any): AxiosPromise<CustomerChatMessage> {
            return localVarFp.messagesPost(messagesGetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get All Unread Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unreadNotificationCountGet(options?: any): AxiosPromise<number> {
            return localVarFp.unreadNotificationCountGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChatsApi - object-oriented interface
 * @export
 * @class ChatsApi
 * @extends {BaseAPI}
 */
export class ChatsApi extends BaseAPI {
    /**
     * Get All Chats
     * @param {number} [page] Pagenumber
     * @param {number} [paginate] Items shown per page
     * @param {number} [customerId] Per customer ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public chatsGet(page?: number, paginate?: number, customerId?: number, options?: AxiosRequestConfig) {
        return ChatsApiFp(this.configuration).chatsGet(page, paginate, customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Show specific chat
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public chatsIdGet(id: number, options?: AxiosRequestConfig) {
        return ChatsApiFp(this.configuration).chatsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get All Messages for Chat
     * @param {number} chatId For chat ID
     * @param {number} [page] Pagenumber
     * @param {number} [paginate] Items shown per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public messagesGet(chatId: number, page?: number, paginate?: number, options?: AxiosRequestConfig) {
        return ChatsApiFp(this.configuration).messagesGet(chatId, page, paginate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Save Chat Message
     * @param {MessagesGetRequest} [messagesGetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public messagesPost(messagesGetRequest?: MessagesGetRequest, options?: AxiosRequestConfig) {
        return ChatsApiFp(this.configuration).messagesPost(messagesGetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get All Unread Notifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatsApi
     */
    public unreadNotificationCountGet(options?: AxiosRequestConfig) {
        return ChatsApiFp(this.configuration).unreadNotificationCountGet(options).then((request) => request(this.axios, this.basePath));
    }
}
